import { render, staticRenderFns } from "./MasterclassManagement.vue?vue&type=template&id=27cd2bef&scoped=true&"
import script from "./MasterclassManagement.vue?vue&type=script&lang=js&"
export * from "./MasterclassManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cd2bef",
  null
  
)

export default component.exports